import type { Fields } from '@lumapps/utils/types/Fields';

import type { QueryClient } from '../react-query';

/**
 * Searches the query cache for a query that has a superset of the requested fields,
 * allowing for better cache reuse.
 */
export function getSupersetFieldsFromCache<T extends object>(
    queryClient: QueryClient,
    queryKey: readonly [...unknown[], Fields<T>],
): Fields<T> {
    const fields = queryKey[queryKey.length - 1] as Fields<T>;
    if (!fields?.length) {
        return fields;
    }
    const queryKeyWithoutFields = queryKey.slice(0, -1);

    for (const [queryKey] of queryClient.getQueriesData(queryKeyWithoutFields)) {
        const cachedFields = queryKey[queryKey.length - 1];
        if (Array.isArray(cachedFields) && fields.every((field) => cachedFields.includes(field))) {
            return cachedFields as Fields<T>;
        }
    }
    return fields;
}
